var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 4C19.8125 4 22.625 11.5 22.625 11.5C22.625 11.5 19.8125 19 12.3125 19C4.8125 19 2 11.5 2 11.5C2 11.5 4.8125 4 12.3125 4ZM12.3125 6.8125C9.72406 6.8125 7.625 8.91156 7.625 11.5C7.625 14.0884 9.72406 16.1875 12.3125 16.1875C14.9009 16.1875 17 14.0884 17 11.5C17 8.91156 14.9009 6.8125 12.3125 6.8125ZM12.3125 8.6875C13.0584 8.6875 13.7738 8.98382 14.3012 9.51126C14.8287 10.0387 15.125 10.7541 15.125 11.5C15.125 12.2459 14.8287 12.9613 14.3012 13.4887C13.7738 14.0162 13.0584 14.3125 12.3125 14.3125C11.5666 14.3125 10.8512 14.0162 10.3238 13.4887C9.79632 12.9613 9.5 12.2459 9.5 11.5C9.5 10.7541 9.79632 10.0387 10.3238 9.51126C10.8512 8.98382 11.5666 8.6875 12.3125 8.6875Z",
    fill: "#9E9FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPass);
export default __webpack_public_path__ + "static/media/show-pass.04045c6c0ad0ffb633e73c97234ba57f.svg";
export { ForwardRef as ReactComponent };